<h1 mat-dialog-title>Gestion identifiants Koovea</h1>
<div mat-dialog-content>
  <p *ngIf="!editMode && !isLoading">
    <ng-container *ngIf="kooveaLogin; else noLogin">
      <b>Login</b> {{kooveaLogin.login}}
      <b>Mot de passe</b> {{kooveaLogin.login ? '***' : ''}}
    </ng-container>

    <ng-template #noLogin>
      <p>Il n'y a actuellement aucun login</p>
    </ng-template>
  </p>

  <mat-spinner *ngIf="isLoading" color="primary" diameter="30"></mat-spinner>

  <form *ngIf="editMode && !isLoading" [formGroup]="form">
    <mat-form-field class="loginField">
      <mat-label>Login</mat-label>
      <input type="text" matInput formControlName="login">
    </mat-form-field>

    <mat-form-field class="passwordField">
      <mat-label>Mot de passe</mat-label>
      <input type="text" matInput formControlName="password">
    </mat-form-field>
  </form>

  <div class="actions">

    <app-validate-and-cancel *ngIf="form && editMode" (submitEvent)="validate($event)" [editForm]="form"
      [disabling]="form.invalid"></app-validate-and-cancel>

    <button *ngIf="!editMode" mat-raised-button color="primary" type="button" (click)="modify()">Modifier</button>
  </div>
</div>